// pages/TarifaSupervision/components/SoporteDropzone.jsx
import { Box, Typography, List, ListItem, ListItemText, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Dropzone from "react-dropzone";

// Mantener en sincronía con los límites reales del backend (uploadMiddleware.js / app.routes.js)
const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB por archivo
const MAX_FILES = 5;

const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};

const describeRejection = ({ file, errors }) => {
  switch (errors?.[0]?.code) {
    case "file-invalid-type":
      return `"${file.name}" no es un PDF y no se agregó.`;
    case "file-too-large":
      return `"${file.name}" supera el tamaño máximo de 5 MB y no se agregó.`;
    default:
      return `"${file.name}" no se pudo agregar.`;
  }
};

export default function SoporteDropzone({ values, setFieldValue, error, palette, borderColor, notify }) {
  return (
    <Dropzone
      name="detalleIngreso"
      accept={{ "application/pdf": [] }}
      maxSize={MAX_FILE_SIZE}
      multiple
      onDrop={(acceptedFiles, fileRejections) => {
        const current = values.detalleIngreso || [];
        const room = Math.max(0, MAX_FILES - current.length);
        const accepted = acceptedFiles.slice(0, room);
        const overflow = acceptedFiles.slice(room);

        if (accepted.length > 0) {
          setFieldValue("detalleIngreso", [...current, ...accepted]);
        }

        const messages = fileRejections.map(describeRejection);
        if (overflow.length > 0) {
          messages.push(
            `Solo se permiten hasta ${MAX_FILES} archivos por aviso. No se agregaron: ${overflow
              .map((f) => `"${f.name}"`)
              .join(", ")}.`
          );
        }
        if (messages.length > 0 && notify) {
          notify("warning", messages.join(" "));
        }
      }}
    >
      {({ getRootProps, getInputProps }) => (
        <Box
          {...getRootProps()}
          border={`2px dashed ${borderColor}`}
          p="1rem"
          sx={{
            "&:hover": { cursor: "pointer" },
            gridColumn: { xs: "span 4", sm: "span 4", md: "span 2" },
          }}
        >
          <input {...getInputProps()} />
          <Typography fontWeight="bold" mb={1}>
            Agregar Documentación Soporte (Solo PDF)
          </Typography>

          <Box display="flex" alignItems="center" gap={1}>
            <UploadFileIcon />
            <Typography>Haz clic o arrastra archivos (Máximo de 5 archivos) aquí para subir</Typography>
          </Box>

          <List dense>
            {(values.detalleIngreso || []).map((file, index) => (
              <ListItem
                key={index}
                secondaryAction={
                  <IconButton
                    edge="end"
                    onClick={(e) => {
                      e.stopPropagation();
                      const updated = values.detalleIngreso.filter((_, i) => i !== index);
                      setFieldValue("detalleIngreso", updated);
                    }}
                  >
                    <DeleteIcon color="error" />
                  </IconButton>
                }
              >
                <ListItemText primary={file.name} secondary={formatFileSize(file.size)} />
              </ListItem>
            ))}
          </List>

          {error && <Typography color="error">{error}</Typography>}
        </Box>
      )}
    </Dropzone>
  );
}
